export var HOOK_SETUP = 'devtools-plugin:setup';
export var HOOK_PLUGIN_SETTINGS_SET = 'plugin:settings:set';
